import GroupsStore from "./groups-store";
import UserStore from "./user-store";

class ApplicationStore {
  user = new UserStore();
  groups = new GroupsStore();
}

export default new ApplicationStore();
